<template>
  <nav
    class="ml-6 space-x-2 xl:ml-0 xl:space-x-4 2xl:space-x-6 hidden lg:flex lg:flex-1"
  >
    <RegularItemMenu :to="'/qr-code-scanner'"
      >📸 {{ $t("scanner") }}
    </RegularItemMenu>
    <RegularItemMenu :to="'/batch-qr-code'">
      📦 {{ $t("batch") }}
    </RegularItemMenu>

    <RegularItemMenu :to="'/pricing'" class="text-primary 2xl:block hidden"
      >🏷️ Pricing
    </RegularItemMenu>
    <PropItemMenu>
      <template v-slot:label>💡 {{ $t("solutions") }}</template>
      <template v-slot:dropdown>
        <div
          class="overflow-hidden shadow-lg rounded-2xl ring-1 ring-black ring-opacity-5 p-4 bg-white"
        >
          <CategoriesSolution :dataLocale="dataLocale" />
        </div>
      </template>
    </PropItemMenu>
    <RegularItemMenu :to="'/contact-us'" class="text-primary 2xl:block hidden"
      >📞 {{ $t("contact") }}
    </RegularItemMenu>
  </nav>
</template>
<script lang="ts" setup>
import RegularItemMenu from "./menu/RegularItemMenu.vue";
import PropItemMenu from "./menu/PropItemMenu.vue";
import CategoriesSolution from "./solutions/CategoriesSolution.vue";
const localePath = useLocalePath();
const props = defineProps({
  dataLocale: {
    type: Object as PropType<{
      data: any;
    }>,
    required: true,
  },
});
</script>
